import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

import { AnimatedBackground, Overline } from "../../components";
import { Google, Okta } from "../../theme/icons";
import API, { TAuthProvider } from "../../api";

function Auth() {
  const [error, setError] = useState<string>();
  const herobgColor = useColorModeValue("white", "base.700");

  const redirectToLogin = (provider: TAuthProvider) => {
    API.getAuthenticationUrl(provider)
      .then((response) => {
        if (!response.ok) throw new Error("Unable to get authentication URL");
        return response.json();
      })
      .then((r) => window.location.assign(r.authorization_url))
      .catch((e) => setError(e.message));
  };

  return (
    <Flex
      p="0"
      w="100%"
      h="calc(100vh - 3rem)"
      maxH="calc(100vh - 3rem)"
      overflow="hidden"
      borderWidth={["8px", null, null, "10px"]}
      borderColor={herobgColor}
      gap="8"
      flexDirection={["column", null, "row"]}
    >
      <AnimatedBackground
        bgImage="/images/jonathan-hsu-PQZHHkXN18Y-unsplash.jpg"
        transform="scaleX(-1)"
        bgSize="cover"
        bgPos={["center", null, "20vw 0"]}
      />
      <Text
        fontSize="xs"
        textDecor="underline"
        color="primary.300"
        position="absolute"
        bottom="4"
        left="4"
      >
        Image &copy;{" "}
        <a
          href="https://unsplash.com/photos/two-humpback-whales-swimming-in-the-ocean-PQZHHkXN18Y"
          target="_blank"
          rel="noopener noreferrer"
        >
          Jonathan Hsu on Unsplash
        </a>
      </Text>
      <Container
        flex="1"
        height={["75%", null, "85%"]}
        right={[0, null, "2rem"]}
        top={["10%", null, "6rem"]}
        background={[
          `linear-gradient(30deg, ${useColorModeValue(
            "white",
            "var(--chakra-colors-base-700)",
          )} 15%, transparent)`,
          null,
          `linear-gradient(-130deg, ${useColorModeValue(
            "white",
            "var(--chakra-colors-base-700)",
          )} 15%, transparent)`,
        ]}
        borderWidth={[0, null, "1px"]}
        borderStyle="solid"
        borderColor={[
          "transparent",
          useColorModeValue(
            "var(--chakra-colors-primary-100a)",
            "var(--chakra-colors-whiteAlpha-200)",
          ),
        ]}
        borderRadius="lg"
        maxW={[null, "container.sm", "container.md"]}
        display="flex"
        justifyContent="center"
        p={[4, null, 12]}
        gap={[4, null, 8]}
        flexDir="column"
        position="absolute"
        backdropFilter="blur(16px)"
      >
        <Heading size={["xl", null, "2xl"]}>Log in or sign up</Heading>
        <Text>Welcome back</Text>
        {error && <Text mb="2">{error}</Text>}
        <Box display="flex" flexDirection="column" gap="3">
          <Button
            variant="outline"
            colorScheme="gray"
            size={["md", null, "xl"]}
            justifyContent="flex-start"
            gap="3"
            onClick={() => redirectToLogin("google")}
          >
            <Google />
            Continue with Google
          </Button>
          <Button
            variant="outline"
            colorScheme="gray"
            size={["md", null, "xl"]}
            justifyContent="flex-start"
            gap="3"
            onClick={() => redirectToLogin("okta")}
          >
            <Okta />
            Continue with Okta
          </Button>
        </Box>
        <Overline mb="8">
          WhalesAI.org requires prior authorization. Please contact for access
        </Overline>
      </Container>
    </Flex>
  );
}

export default Auth;
